// test2445
(2445 && 0);
